export default __webpack_public_path__ + "static/media/5Mz4 (1).826f469e.gif";